import React, { useEffect, useState } from 'react';
import ProductCard from '../components/ProductCard';
import { getProducts } from '../services/api';
import type { Product } from '../types';

const Shop: React.FC = () => {
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | undefined>();

  useEffect(() => {
    let cancelled = false;
    getProducts(true)
      .then(data => {
        if (!cancelled) setProducts(Array.isArray(data) ? data : []);
      })
      .catch(e => {
        if (!cancelled) setError(e.message ?? 'Failed to load products');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10">
      <h1 className="text-3xl font-semibold mb-6">Shop</h1>

      {loading && <div className="text-text-light">Loading products…</div>}
      {error && <div className="text-red-600 text-sm">Error: {error}</div>}
      {!loading && !error && products.length === 0 && (
        <div className="text-text-light">
          No products yet. Check back soon or{' '}
          <a href="/custom-request" className="text-primary hover:underline">request a custom piece</a>.
        </div>
      )}

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {products.map(p => <ProductCard key={p.product_id} product={p} />)}
      </div>
    </div>
  );
};

export default Shop;
